module.exports = __webpack_public_path__ + "static/media/product-bottom-background-pattern.f679e158.svg";